import { createFileRoute } from "@tanstack/react-router";
import { AgentGroupDetail } from "../../features/agents/agentgroup-detail";

export const Route = createFileRoute("/_authed/$org/$project/agentgroups/$name/$tab")({ component: AgentGroupPage });

function AgentGroupPage() {
  const { org, project, name, tab } = Route.useParams();
  return <AgentGroupDetail scope={{ org, project }} name={name} tab={tab} />;
}
